<full-screen-loading />

@if (authMicrosoft.isLoggedSignal()) {
  <div>
  <!-- BEGIN #app -->
  <div id="app" class="app"[ngClass]="{
    'has-scroll' : appHasScroll,
    'app-sidebar-minified': appSettings.appSidebarMinified,
		'app-sidebar-fixed': !appSettings.appSidebarNone && appSettings.appSidebarFixed,
		'app-header-fixed': !appSettings.appHeaderNone && appSettings.appHeaderFixed,
    'app-without-sidebar': appSettings.appSidebarNone || appSettings.appEmpty,
    'app-without-header': appSettings.appHeaderNone || appSettings.appEmpty,
    'app-with-end-sidebar': appSettings.appSidebarEnd,
    'app-with-two-sidebar': appSettings.appSidebarTwo,
    'app-with-wide-sidebar': appSettings.appSidebarWide,
    'app-sidebar-end-toggled': appSettings.appSidebarEndToggled,
    'app-sidebar-mobile-toggled': appSettings.appSidebarMobileToggled,
    'app-content-full-height': appSettings.appContentFullHeight,
    'app-with-top-menu': appSettings.appTopMenu,
    'app-sidebar-end-mobile-toggled': appSettings.appSidebarEndMobileToggled,
    'app-gradient-enabled': appSettings.appGradientEnabled,
    'p-0': appSettings.appEmpty
  }">
      @if (!appSettings.appEmpty && !appSettings.appHeaderNone) {
        <header
          (appSidebarMobileToggled)="onAppSidebarMobileToggled($event)"
          (appSidebarEndToggled)="onAppSidebarEndToggled($event)"
          (appSidebarEndMobileToggled)="onAppSidebarEndMobileToggled($event)"
          [appSidebarTwo]="appSettings.appSidebarTwo"
          >
        </header>
      }
      @if (!appSettings.appSidebarNone && !appSettings.appEmpty) {
        <sidebar
          (appSidebarMinifiedToggled)="onAppSidebarMinifiedToggled($event)"
          (appSidebarMobileToggled)="onAppSidebarMobileToggled($event)"
          [appSidebarMinified]="appSettings.appSidebarMinified"
          >
        </sidebar>
      }
      <div id="content" class="app-content" [ngClass]="appSettings.appContentClass + ' ' + (appSettings.appEmpty ? 'p-0 m-0' : '')">
        <router-outlet></router-outlet>
      </div>
     
    </div> 
    <!-- END #app -->
  </div>
  }
  
  <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 9999">
    @for(toast of toastService.toastsSignal(); track toast.id){
    <div class="toast show" role="alert"
      [ngClass]="{'bg-success text-white': toast.type === 'success', 'bg-danger text-white': toast.type === 'error', 'bg-info text-white': toast.type === 'info', 'bg-warning': toast.type === 'warning'}">
      <div class="toast-header"
        [ngClass]="{'bg-success text-white': toast.type === 'success', 'bg-danger text-white': toast.type === 'error', 'bg-info text-white': toast.type === 'info', 'bg-warning': toast.type === 'warning'}">
        <i class="fas me-2"
          [ngClass]="{'fa-check-circle': toast.type === 'success', 'fa-times-circle': toast.type === 'error', 'fa-info-circle': toast.type === 'info', 'fa-exclamation-triangle': toast.type === 'warning'}"></i>
        <strong class="me-auto">{{toast.type === 'success' ? 'Éxito' : toast.type === 'error' ? 'Error' : toast.type === 'info' ? 'Información' : 'Advertencia'}}</strong>
        <button type="button" class="btn-close" [ngClass]="{'btn-close-white': toast.type !== 'warning'}" (click)="toastService.dismiss(toast.id)"></button>
      </div>
      <div class="toast-body">{{toast.message}}</div>
    </div>
    }
  </div>